import { useCallback, useState } from 'react';

import { StorageManager } from '../services/storage/StorageManager';

export const useStorageState = <T extends string>(storageKey: string): [T | null, (_value: T | null) => void] => {
  const [state, setState] = useState<T | null>(StorageManager.getItem<T>(storageKey));

  const updateState = useCallback(
    (value: T | null) => {
      setState(value);
      if (value === null) {
        StorageManager.removeItem(storageKey);
      } else {
        StorageManager.setItem(storageKey, value);
      }
    },
    [storageKey],
  );

  return [state, updateState];
};
